export default __webpack_public_path__ + "static/media/camera_poor.42defb80.svg";